import toTitleCase from './toTitleCase';

function getFirstNameLastInitial (firstName: string, lastName: string) {

	return `${toTitleCase(firstName) || ''} ${lastName.charAt(0).toUpperCase() || ''}${
		lastName ? '.' : ''
	}`;

}

export default getFirstNameLastInitial;
